var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Capitalize a string
 */
export function capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}
// https://thecodebarbarian.com/basic-functional-programming-with-async-await
// https://www.npmjs.com/package/p-reduce
// https://medium.com/@antonioval/making-array-iteration-easy-when-using-async-await-6315c3225838
export function forEachAsync(arr, fn) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, arr.reduce(function (promise, n) {
                    return promise.then(function () { return fn(n); });
                }, Promise.resolve())];
        });
    });
}
/**
 * Returns a holder name or email (if name is not available)
 */
export function getDisplayName(entity) {
    var displayName = entity.holder.name
        ? entity.holder.name
        : entity.holder.email;
    if (!displayName) {
        throw new Error('Holder name or email must exist');
    }
    return displayName;
}
/**
 * Returns null when the argument (eg valuationCap) is 0
 */
export function ZeroToNull(value) {
    // export function CappedOrUnCapped(valuationCap: number) {
    if (value === 0) {
        return null;
    }
    return value;
}
/**
 * Returns valuation cap value with headline, or string "Uncapped" (used in lists)
 */
export function getValuationCapList(valuationCap) {
    if (typeof valuationCap === 'number') {
        return 'Valuation cap USD ' + thousandSeparator(valuationCap);
    }
    return 'Uncapped';
}
/**
 * Returns valuation cap value, or string "Uncapped" (used in detail views)
 */
export function getValuationCapDetail(valuationCap) {
    if (typeof valuationCap === 'number') {
        return thousandSeparator(valuationCap);
    }
    return 'Uncapped';
}
/**
 * Returns total principal (authorized amount) value, or string "Unlimited" (used in detail views)
 */
export function getTotalPrincipalDetail(totalPrincipal) {
    if (typeof totalPrincipal === 'number') {
        return thousandSeparator(totalPrincipal);
    }
    return 'Unlimited';
}
/**
 * Returns a capitalized lowercase string, for the enum valuationBasis
 */
export function getValuationBasisDisplayName(valuationBasis) {
    if (valuationBasis === 'PRE_MONEY') {
        return 'Pre-money';
    }
    return 'Post-money';
}
/**
 * Takes a number and returns of the number with thousand separators
 */
export function thousandSeparator(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
/**
 * Returns a string of a number with decimals padded to the specified count
 */
export function padNumber(num, decimals) {
    if (decimals === void 0) { decimals = 2; }
    return (Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
}
//# sourceMappingURL=utils.js.map